import { LegalLayout } from "../components/LegalLayout";
import { TERMS } from "../data/legal";

export default function Terms() {
  return (
    <LegalLayout
      doc={TERMS}
      path="/terms"
      seoTitle="Terms & Conditions | ZasyaOnline"
      seoDescription="Terms of Use for ZasyaOnline's websites, software applications and services, including user eligibility, licence and ownership, fees, termination, and governing law."
      testId="terms-page"
    />
  );
}
